import React from 'react';
import { useWnstnContext } from './wnstn-widget.context';

export interface WnstnWrapperProps {
    children: React.ReactNode;
}

export const WnstnWrapper: React.FC<WnstnWrapperProps> = ({ children }) => {
    const { shouldRender } = useWnstnContext();

    if (!shouldRender) {
        return null;
    }

    return <>{children}</>;
};
